import "@/components/sentryClient";
import * as Sentry from "@sentry/react";
import React from "react";

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => (
	<Sentry.ErrorBoundary>{children}</Sentry.ErrorBoundary>
);
